import { MDBCard } from 'mdb-react-ui-kit'
import classes from './FriendlyInfoBox.module.css'

function FriendlyInfoBox( { children } ) {
  return (
    <MDBCard className={`${classes.infoBox} p-3`}>{children}</MDBCard>
  )
}

export default FriendlyInfoBox